import type { TCommon, TGeneral } from '@/src/types/common'
import { ref } from 'vue'
import { domToCanvas } from 'modern-screenshot'
import benchmarkChartLogo from '~/assets/icons/BenchmarkChartLogo.svg?url'

export function useDownloadChart() {
  const { $watermarkjs, $rudderstack } = useNuxtApp()
  const downloadingChart = ref(false)

  const filter = (node: HTMLElement) => {
    const exclusionClasses = ['remove-me']
    return !exclusionClasses.some((classname) =>
      node.classList?.contains(classname),
    )
  }

  const downloadChart = async ({
    name = 'gigafactories.png',
    watermarkLocations = ['center'],
    watermarkLocationsPosition = [
      {
        x(target: TCommon, mark: TCommon) {
          return (target.width - mark.width) / 2
        },
        y() {
          return 10
        },
      },
      {
        x(target: TCommon, mark: TCommon) {
          return (target.width - mark.width) / 2
        },
        y(target: TCommon, mark: TCommon) {
          return target.height - (mark.height + 10)
        },
      },
    ],
  }: TGeneral = {}) => {
    downloadingChart.value = true

    const canvas = await domToCanvas(document.querySelector('#chart-canvas'), {
      filter,
      backgroundColor: '#fff',
    })

    canvas.toBlob((blob: Blob) => {
      let watermark = $watermarkjs([blob, benchmarkChartLogo])
      for (const location of watermarkLocations) {
        watermark = watermark
          .dataUrl($watermarkjs.image[location](0.3))
          .load([benchmarkChartLogo])
      }

      if (canvas.height >= 1000) {
        for (const location of watermarkLocationsPosition) {
          watermark = watermark
            .dataUrl($watermarkjs.image.atPos(location.x, location.y, 0.3))
            .load([benchmarkChartLogo])
        }
      }
      watermark
        .dataUrl((target: TCommon, _logo: TCommon) => target)
        .then((url: string) => {
          const link = document.createElement('a')
          link.setAttribute('download', name)
          link.href = url
          link.click()

          $rudderstack.trackChartDownload({
            chart_type: 'lines',
            element_id: '#chart-canvas',
            chart_title: name,
            download_format: 'png',
          })
          downloadingChart.value = false
        })
    }, 'image/png')
  }

  return {
    downloadingChart,
    downloadChart,
    filter,
  }
}
